import { createTheme, Theme as MuiTheme } from '@mui/material/styles';
import { DefaultTheme } from 'styled-components';

export const muiLight = createTheme({
  typography: {
    fontFamily: "'Noka', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  palette: {
    mode: 'light',
    primary: { main: '#13438bff' },
    secondary: { main: '#6c6e6cff' },
    background: { default: '#FFFFFF' },
    text: { primary: '#000' },
    error: { main: '#e53935' },
  },
}); 


export const muiDark: MuiTheme = createTheme({
  typography: {
    fontFamily: "'Noka', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  palette: {
    mode: 'dark',
    primary: { main: '#13438bff' },
    secondary: { main: '#6c6e6cff' },
    background: { default: '#232321', },
    text: { primary: '#fff' },
    error: { main: '#ef5350' },
  },
});

export const scLight: DefaultTheme = {
  mode: 'light',
  base_color: '#D9D9D9',
  menu_hover: "rgba(217, 217, 217, 0.8)",
  font_color: '#1C2724',
  blue_color: '#4f46e5',
  blue_color_hover: '#4338ca',
  default_color: '#e7e7eb',
  user_message_background: '#f4f4f4',
  loading_message: '#555555',
  dropdown_menu_item_font_color: '#000',
  menu_item_description_color: '#6c6c6c',
  user_menu_background: '#D9D9D9',
  action_icon_color: '#88898bff',
  text_secondary: '#6c6c6c',
  secondary_text_color: '#6c6c6c',
  gray_hover: '#495057',
  dark_blue: '#2D3748',
  desc_color: '#718096',
  borderGrey: '#e2e8f0',
  // Error Message Component
  error_message_text: '#dc2626',
  error_retry_button_bg: '#ef4444',
  error_retry_button_hover: '#dc2626',
  error_plans_button_bg: '#15803d',
  error_plans_button_hover: '#166534',
  // Modal/Subscription
  modal_background: '#FFFFFF',
  modal_overlay: 'rgba(0, 0, 0, 0.5)',
  modal_border: '#e5e7eb',
  payment_modal_background: '#FFFFFF',
  payment_modal_border: '#e5e7eb',
  payment_modal_text: '#1C2724',
  payment_modal_text_secondary: '#6c6c6c',
  payment_modal_scrollbar: '#e5e7eb',
  payment_modal_scrollbar_hover: '#6c6c6c',
  payment_modal_input_disabled_bg: '#f5f7f6',
  // Inputs
  selection_background: '#445061ff',
  selection_color: '#f8fafc',
  input_surface_bg: '#ffffff',
  // Buttons
  hover_overlay_light: 'rgba(0, 0, 0, 0.05)',
  // Recording
  recording_bg: 'rgba(248, 113, 113, 0.12)',
  recording_bg_hover: 'rgba(248, 113, 113, 0.2)',
  recording_border: '#ef4444',
  recording_icon: '#ef4444',
  // Send button
  send_button_bg: '#32d74b',
  send_button_hover: '#28c943',
  send_button_disabled: 'rgba(50, 215, 75, 0.4)',
  // Loading dots
  loading_dot_color: '#6b7280',
  // Arrows/Icons
  arrow_icon_color: '#374151',
  // User menu
  user_menu_border: '#e9e9e9',
  user_menu_divider: 'rgba(0, 0, 0, 0.08)',
  // Sidebar
  sidebar_background: 'rgba(243, 243, 243, 0.7)',
  sidebar_background_solid: '#f3f3f3',
  sidebar_border: 'rgba(15, 23, 42, 0.08)',
  sidebar_scrollbar: 'rgba(0, 0, 0, 0.2)',
  sidebar_scrollbar_hover: 'rgba(0, 0, 0, 0.3)',
  sidebar_folder_hover_bg: 'rgba(0, 0, 0, 0.03)',
  sidebar_folder_hover_shadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  sidebar_chat_active_bg: 'rgba(0, 0, 0, 0.05)',
  sidebar_cta_bg: '#F3F3F3',
  sidebar_cta_border: 'rgba(0, 0, 0, 0.12)',
  // File placeholders - PDF
  file_pdf_card_bg: '#ffffff',
  file_pdf_border: 'rgba(15, 23, 42, 0.08)',
  file_pdf_icon_bg: '#ff6b6b',
  file_pdf_icon_color: '#ffffff',
  file_pdf_name_color: '#1f2937',
  file_pdf_type_color: 'rgba(17, 24, 39, 0.65)',
  // File placeholders - Image
  file_image_card_bg: '#ffffff',
  file_image_border: 'rgba(15, 23, 42, 0.08)',
  file_image_icon_bg: '#2dd4bf',
  file_image_icon_color: '#0f172a',
  file_image_name_color: '#1f2937',
  file_image_type_color: 'rgba(17, 24, 39, 0.65)',
  // File placeholders - Generic
  file_generic_card_bg: '#ffffff',
  file_generic_border: 'rgba(15, 23, 42, 0.08)',
  file_generic_icon_bg: '#8b5cf6',
  file_generic_icon_color: '#ffffff',
  file_generic_name_color: '#1f2937',
  file_generic_type_color: 'rgba(17, 24, 39, 0.65)',
  // File placeholders - CSV
  file_csv_card_bg: '#ffffff',
  file_csv_border: 'rgba(15, 23, 42, 0.08)',
  file_csv_icon_bg: '#22c55e',
  file_csv_icon_color: '#ffffff',
  file_csv_name_color: '#1f2937',
  file_csv_type_color: 'rgba(17, 24, 39, 0.65)',
  // File placeholders - TXT
  file_txt_card_bg: '#ffffff',
  file_txt_border: 'rgba(15, 23, 42, 0.08)',
  file_txt_icon_bg: '#3b82f6',
  file_txt_icon_color: '#ffffff',
  file_txt_name_color: '#1f2937',
  file_txt_type_color: 'rgba(17, 24, 39, 0.65)',
  // File thumbnails
  file_thumb_border: 'rgba(0, 0, 0, 0.08)',
  file_remove_overlay_bg: 'rgba(0, 0, 0, 0.45)',
  file_remove_overlay_hover: 'rgba(0, 0, 0, 0.6)',
  file_remove_overlay_border: 'rgba(0, 0, 0, 0.15)',
  file_page_badge_bg: 'rgba(0, 0, 0, 0.55)',
  file_page_badge_border: 'rgba(0, 0, 0, 0.15)',
  // Preview/Lightbox
  preview_overlay_bg: 'rgba(0, 0, 0, 0.6)',
  preview_dialog_bg: '#fff',
  preview_header_border: 'rgba(0, 0, 0, 0.08)',
  preview_text_bg: 'rgba(15, 23, 42, 0.04)',
  preview_shadow: 'rgba(0, 0, 0, 0.25)',
  // Generic article icon
  article_icon_color: 'rgb(133, 133, 133)',
  // Scroll to bottom button
  scroll_button_bg: 'rgba(255, 255, 255, 0.76)',
  // Model selector
  model_selector_bg: '#ffffff',
  model_selector_border: '#e5e7eb',
  model_selector_hover_bg: '#f9fafb',
  model_selector_option_border: '#d1d5db',
  model_selector_option_bg: '#f9fafb',
  model_selector_option_hover_bg: '#f3f4f6',
  model_selector_divider: '#c1c1c1',
  model_selector_badge_bg: '#ffffff',
  // Subscription banner
  banner_icon_color: '#0b1120',
  banner_highlight_bg: '#eef2ff',
  banner_description_color: '#6b7280',
  // Feedback modal
  feedback_modal_input_bg: '#ffffff',
  feedback_modal_input_border: '#d1d5db',
  feedback_modal_input_color: '#1f2937',
  feedback_modal_input_placeholder: '#6b7280',
  feedback_modal_title_color: '#1f2937',
  feedback_modal_close_icon_color: '#6b7280',
  feedback_modal_close_icon_hover: '#374151',
  feedback_modal_button_outlined_bg: '#ffffff',
  feedback_modal_button_outlined_border: '#d1d5db',
  feedback_modal_button_outlined_color: '#374151',
  feedback_modal_button_outlined_hover_bg: '#f9fafb',
  feedback_modal_button_contained_bg: '#4f46e5',
  feedback_modal_button_contained_color: '#ffffff',
  feedback_modal_button_contained_hover_bg: '#4338ca',
  feedback_modal_submit_button_bg: '#4f46e5',
  feedback_modal_submit_button_color: '#ffffff',
  feedback_modal_submit_button_hover_bg: '#4338ca',
  feedback_modal_submit_button_disabled_bg: 'rgba(79, 70, 229, 0.4)',
  // Subscription/Plan status colors
  plan_warning_color: '#FF7F40',
  plan_success_color: '#79D44B',
  // Prompt Bank (neutro + verde escuro da marca #1a3c34)
  prompt_category_card_bg: '#f8fafc',
  prompt_category_card_border: '#e2e8f0',
  prompt_category_card_hover: '#f1f5f9',
  prompt_category_icon_bg: 'rgba(0, 0, 0, 0.04)',
  prompt_variable_bg: 'rgba(0, 0, 0, 0.03)',
  prompt_variable_border: 'rgba(0, 0, 0, 0.1)',
  prompt_variable_text: '#1a3c34',
  prompt_variable_focus_border: '#1a3c34',
  prompt_preview_bg: '#f9fafb',
  prompt_item_bg: '#ffffff',
  prompt_item_border: '#e5e7eb',
  prompt_item_hover: 'rgba(0, 0, 0, 0.02)',
  prompt_accent_color: '#1a3c34',
  prompt_accent_hover: '#15302a',
  // Markdown tables
  table_header_bg: '#eaf5e6',
  table_header_color: '#1a3a12',
  table_border: '#d0e4c8',
  table_row_hover_bg: 'rgba(112, 212, 75, 0.10)',
  // Charts
  chart_bg: '#ffffff',
  chart_border: '#e5e7eb',
};

export const scDark: DefaultTheme = {
  mode: 'dark',
  base_color: '#232321',
  menu_hover: "rgba(35, 35, 33, 0.8)",
  font_color: '#fff',
  blue_color: '#8ab4f8',
  blue_color_hover: '#6fa1f5',
  default_color: '#3a3a3a',
  user_message_background: '#31312f',
  loading_message: '#d4d4d4',
  dropdown_menu_item_font_color: '#fff',
  menu_item_description_color: '#a1a1a1',
  user_menu_background: '#232321',
  action_icon_color: '#8f8f8fff',
  text_secondary: '#a1a1a1',
  secondary_text_color: '#a1a1a1',
  gray_hover: '#6c757d',
  dark_blue: '#4A90E2',
  desc_color: '#a1a1a1',
  borderGrey: '#404040',
  // Error Message Component
  error_message_text: '#f87171',
  error_retry_button_bg: '#dc2626',
  error_retry_button_hover: '#b91c1c',
  error_plans_button_bg: '#15803d',
  error_plans_button_hover: '#166534',
  // Modal/Subscription
  modal_background: '#232321',
  modal_overlay: 'rgba(0, 0, 0, 0.7)',
  modal_border: '#404040',
  payment_modal_background: '#2c2c2a',
  payment_modal_border: '#404040',
  payment_modal_text: '#f9fafb',
  payment_modal_text_secondary: '#a1a1a1',
  payment_modal_scrollbar: '#404040',
  payment_modal_scrollbar_hover: '#6b7280',
  payment_modal_input_disabled_bg: '#1f1f1f',
  // Inputs
  selection_background: '#bdaa60ff',
  selection_color: '#1f2937',
  input_surface_bg: '#2c2c2a',
  // Buttons
  hover_overlay_light: 'rgba(255, 255, 255, 0.08)',
  // Recording
  recording_bg: 'rgba(248, 113, 113, 0.18)',
  recording_bg_hover: 'rgba(248, 113, 113, 0.28)',
  recording_border: '#f87171',
  recording_icon: '#fca5a5',
  // Send button
  send_button_bg: '#22c55e',
  send_button_hover: '#1fb454',
  send_button_disabled: 'rgba(34, 197, 94, 0.3)',
  // Loading dots
  loading_dot_color: '#9ca3af',
  // Arrows/Icons
  arrow_icon_color: '#e5e7eb',
  // User menu
  user_menu_border: '#404040',
  user_menu_divider: 'rgba(255, 255, 255, 0.1)',
  // Sidebar
  sidebar_background: '#1a1a18',
  sidebar_background_solid: '#1a1a18',
  sidebar_border: 'rgba(255, 255, 255, 0.12)',
  sidebar_scrollbar: 'rgba(255, 255, 255, 0.2)',
  sidebar_scrollbar_hover: 'rgba(255, 255, 255, 0.3)',
  sidebar_folder_hover_bg: 'rgba(255, 255, 255, 0.05)',
  sidebar_folder_hover_shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
  sidebar_chat_active_bg: 'rgba(255, 255, 255, 0.1)',
  sidebar_cta_bg: '#D9D9D9',
  sidebar_cta_border: 'rgba(255, 255, 255, 0.18)',
  // File placeholders - PDF
  file_pdf_card_bg: 'rgba(255, 255, 255, 0.05)',
  file_pdf_border: 'rgba(255, 255, 255, 0.08)',
  file_pdf_icon_bg: '#ff5c5c',
  file_pdf_icon_color: '#ffffff',
  file_pdf_name_color: '#f9fafb',
  file_pdf_type_color: 'rgba(249, 250, 251, 0.72)',
  // File placeholders - Image
  file_image_card_bg: 'rgba(255, 255, 255, 0.05)',
  file_image_border: 'rgba(255, 255, 255, 0.08)',
  file_image_icon_bg: '#22d3ee',
  file_image_icon_color: '#0b1120',
  file_image_name_color: '#f9fafb',
  file_image_type_color: 'rgba(241, 245, 249, 0.74)',
  // File placeholders - Generic
  file_generic_card_bg: 'rgba(255, 255, 255, 0.05)',
  file_generic_border: 'rgba(255, 255, 255, 0.08)',
  file_generic_icon_bg: '#a855f7',
  file_generic_icon_color: '#1e1e2f',
  file_generic_name_color: '#f9fafb',
  file_generic_type_color: 'rgba(241, 245, 249, 0.74)',
  // File placeholders - CSV
  file_csv_card_bg: 'rgba(255, 255, 255, 0.05)',
  file_csv_border: 'rgba(255, 255, 255, 0.08)',
  file_csv_icon_bg: '#34d399',
  file_csv_icon_color: '#0b1120',
  file_csv_name_color: '#f9fafb',
  file_csv_type_color: 'rgba(241, 245, 249, 0.74)',
  // File placeholders - TXT
  file_txt_card_bg: 'rgba(255, 255, 255, 0.05)',
  file_txt_border: 'rgba(255, 255, 255, 0.08)',
  file_txt_icon_bg: '#60a5fa',
  file_txt_icon_color: '#0b1120',
  file_txt_name_color: '#f9fafb',
  file_txt_type_color: 'rgba(241, 245, 249, 0.74)',
  // File thumbnails
  file_thumb_border: 'rgba(255, 255, 255, 0.12)',
  file_remove_overlay_bg: 'rgba(0, 0, 0, 0.65)',
  file_remove_overlay_hover: 'rgba(0, 0, 0, 0.8)',
  file_remove_overlay_border: 'rgba(255, 255, 255, 0.2)',
  file_page_badge_bg: 'rgba(0, 0, 0, 0.7)',
  file_page_badge_border: 'rgba(255, 255, 255, 0.2)',
  // Preview/Lightbox
  preview_overlay_bg: 'rgba(0, 0, 0, 0.8)',
  preview_dialog_bg: '#1f1f1f',
  preview_header_border: 'rgba(255, 255, 255, 0.12)',
  preview_text_bg: 'rgba(255, 255, 255, 0.08)',
  preview_shadow: 'rgba(0, 0, 0, 0.5)',
  // Generic article icon
  article_icon_color: '#e2e2e2ff',
  // Scroll to bottom button
  scroll_button_bg: 'rgba(17, 24, 39, 0.68)',
  // Model selector
  model_selector_bg: '#374151',
  model_selector_border: '#4b5563',
  model_selector_hover_bg: '#4b5563',
  model_selector_option_border: '#4b5563',
  model_selector_option_bg: 'rgba(75, 85, 99, 0.12)',
  model_selector_option_hover_bg: 'rgba(75, 85, 99, 0.2)',
  model_selector_divider: '#606060',
  model_selector_badge_bg: '#ffffff',
  // Subscription banner
  banner_icon_color: '#ffffff',
  banner_highlight_bg: 'rgba(255, 255, 255, 0.08)',
  banner_description_color: '#9ca3af',
  // Feedback modal
  feedback_modal_input_bg: 'rgba(255, 255, 255, 0.05)',
  feedback_modal_input_border: '#4b5563',
  feedback_modal_input_color: '#f9fafb',
  feedback_modal_input_placeholder: '#9ca3af',
  feedback_modal_title_color: '#f9fafb',
  feedback_modal_close_icon_color: '#9ca3af',
  feedback_modal_close_icon_hover: '#e5e7eb',
  feedback_modal_button_outlined_bg: 'rgba(255, 255, 255, 0.05)',
  feedback_modal_button_outlined_border: '#4b5563',
  feedback_modal_button_outlined_color: '#e5e7eb',
  feedback_modal_button_outlined_hover_bg: 'rgba(255, 255, 255, 0.1)',
  feedback_modal_button_contained_bg: '#8ab4f8',
  feedback_modal_button_contained_color: '#0b1120',
  feedback_modal_button_contained_hover_bg: '#6fa1f5',
  feedback_modal_submit_button_bg: '#8ab4f8',
  feedback_modal_submit_button_color: '#0b1120',
  feedback_modal_submit_button_hover_bg: '#6fa1f5',
  feedback_modal_submit_button_disabled_bg: 'rgba(138, 180, 248, 0.3)',
  // Subscription/Plan status colors
  plan_warning_color: '#ff9966',
  plan_success_color: '#88dd66',
  // Prompt Bank (neutro + verde escuro da marca)
  prompt_category_card_bg: 'rgba(255, 255, 255, 0.05)',
  prompt_category_card_border: 'rgba(255, 255, 255, 0.1)',
  prompt_category_card_hover: 'rgba(255, 255, 255, 0.08)',
  prompt_category_icon_bg: 'rgba(255, 255, 255, 0.06)',
  prompt_variable_bg: 'rgba(255, 255, 255, 0.05)',
  prompt_variable_border: 'rgba(255, 255, 255, 0.1)',
  prompt_variable_text: '#7bc9a0',
  prompt_variable_focus_border: '#5da88a',
  prompt_preview_bg: 'rgba(255, 255, 255, 0.03)',
  prompt_item_bg: 'rgba(255, 255, 255, 0.06)',
  prompt_item_border: 'rgba(255, 255, 255, 0.14)',
  prompt_item_hover: 'rgba(255, 255, 255, 0.04)',
  prompt_accent_color: '#5da88a',
  prompt_accent_hover: '#6dba9a',
  // Markdown tables
  table_header_bg: 'rgba(112, 212, 75, 0.15)',
  table_header_color: '#c8f0b8',
  table_border: 'rgba(255, 255, 255, 0.10)',
  table_row_hover_bg: 'rgba(112, 212, 75, 0.08)',
  // Charts
  chart_bg: '#2c2c2a',
  chart_border: '#404040',
};

export default scLight;
